// extracted by mini-css-extract-plugin
module.exports = {"errorTitle":"ILfdCNINl9ZZiamD23w36w==","errorBody":"Zwb95gok853HT80LKOo2XQ=="};